(() => {
  const hero = document.querySelector('[data-m3d-hero-slideshow]');
  if (!hero) return;

  const slides = [...hero.querySelectorAll('[data-m3d-hero-slide]')];
  const chips = [...hero.querySelectorAll('[data-m3d-hero-chip]')];
  const featured = document.querySelector('.m3d-featured');
  const intro = featured?.querySelector('.m3d-featured-intro');
  const products = featured?.querySelector('.m3d-products');
  const originalFeatured = featured ? {
    eyebrow: intro?.querySelector('.m3d-eyebrow')?.textContent || 'Our selection',
    title: intro?.querySelector('.m3d-title')?.innerHTML || 'Professional<br>equipment.<br>Premium results.',
    copy: intro?.querySelector('.m3d-copy')?.textContent || 'Carefully selected technologies from the world’s leading brands.',
    cta: intro?.querySelector('.m3d-pill')?.innerHTML || 'Discover all products <span class="m3d-arrow">→</span>',
    html: products?.innerHTML || ''
  } : null;

  const updateFeatured = (sector) => {
    if (!featured || !intro || !products || !originalFeatured) return;
    const set = document.querySelector(`template[data-m3d-featured-sector="${sector}"]`)?.content;
    const eyebrow = intro.querySelector('.m3d-eyebrow');
    const title = intro.querySelector('.m3d-title');
    const copy = intro.querySelector('.m3d-copy');
    const cta = intro.querySelector('.m3d-pill');
    if (!set) {
      if (eyebrow) eyebrow.textContent = originalFeatured.eyebrow;
      if (title) title.innerHTML = originalFeatured.title;
      if (copy) copy.textContent = originalFeatured.copy;
      if (cta) cta.innerHTML = originalFeatured.cta;
      products.innerHTML = originalFeatured.html;
      return;
    }
    if (eyebrow) eyebrow.textContent = set.querySelector(".m3d-eyebrow").textContent;
    if (title) title.innerHTML = set.querySelector(".m3d-title").innerHTML;
    if (copy) copy.textContent = set.querySelector(".m3d-copy").textContent;
    if (cta) cta.innerHTML = set.querySelector(".m3d-pill").innerHTML;
    products.innerHTML = set.querySelector(".m3d-products").innerHTML;
  };

  if (!slides.length) return;
  let index = 0;
  let timer;

  const show = (next, autoplay = true) => {
    index = next % slides.length;
    const sector = slides[index].dataset.sector || 'overview';
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    chips.forEach((chip) => chip.classList.toggle('is-active', (chip.dataset.sector || 'overview') === sector));
    document.body.dataset.m3dSector = sector;
    updateFeatured(sector);
    window.dispatchEvent(new CustomEvent('m3d:sector-change', { detail: { sector } }));
    window.clearTimeout(timer);
  };

  const showSector = (sector, autoplay = false) => {
    const slideIndex = slides.findIndex((slide) => (slide.dataset.sector || 'overview') === sector);
    show(slideIndex >= 0 ? slideIndex : 0, autoplay);
  };

  // Fragments select homepage views without creating separate indexable pages.
  const rootPath = window.Shopify?.routes?.root || '/';
  const normalizePath = path => path.replace(/\/+$/, '') || '/';
  const syncHomepage = normalizePath(location.pathname) === normalizePath(rootPath) && !window.Shopify?.designMode;
  const sectorHashes = {overview: '', education: 'education', construction: 'construction', industrie: 'industry', defense: 'defense', culture: 'culture', health: 'health', dental: 'dental'};
  const readSector = () => {
    const hash = location.hash.slice(1).toLowerCase();
    if (hash.startsWith('industry-')) return 'industrie';
    return Object.keys(sectorHashes).find(key => sectorHashes[key] === hash) || (hash === 'industrie' ? 'industrie' : null);
  };
  const selectSector = sector => {
    showSector(sector, false);
    if (!syncHomepage) return;
    const hash = sectorHashes[document.body.dataset.m3dSector] || '';
    const url = location.pathname + location.search + (hash ? '#' + hash : '');
    if (url !== location.pathname + location.search + location.hash) history.pushState(history.state, '', url);
  };
  const restoreSector = () => {
    const sector = readSector();
    if (sector !== null) showSector(sector, false);
  };
  if (syncHomepage) {
    window.addEventListener('popstate', restoreSector);
    window.addEventListener('hashchange', restoreSector);
  }
  chips.forEach((chip) => chip.addEventListener('click', () => selectSector(chip.dataset.sector || 'overview')));
  document.querySelectorAll('[data-m3d-mega-sector]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      selectSector(link.dataset.m3dMegaSector || 'overview');
    });
  });
  showSector(syncHomepage ? (readSector() || 'overview') : 'overview', false);
})();
